<template>
  <GenericCard
    :locked="locked"
    :on-action="submitForm"
    :invalid="v$.peParty.$invalid"
    :dirty="v$.peParty.$anyDirty"
    title="History Overview"
    :view-only="viewOnly"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="peParty.years_education"
            autocomplete="off"
            label="# Years of Education"
            outlined
            type="number"
            :error-messages="getErrorMessages(v$.peParty.years_education)"
            @input="v$.peParty.years_education.$touch()"
            @blur="v$.peParty.years_education.$touch()"
          />
        </v-col>
        <v-col cols="auto">
          <label for="any_work_history">Work history?</label>
          <v-radio-group
            id="any_work_history"
            v-model="peParty.any_work_history"
            row
            :error-messages="getErrorMessages(v$.peParty.any_work_history)"
            class="mt-0"
            @input="v$.peParty.any_work_history.$touch()"
            @blur="v$.peParty.any_work_history.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="auto">
          <label for="any_criminal_history">Notable criminal history?</label>
          <v-radio-group
            id="any_criminal_history"
            v-model="peParty.any_criminal_history"
            row
            :error-messages="getErrorMessages(v$.peParty.any_criminal_history)"
            class="mt-0"
            @input="v$.peParty.any_criminal_history.$touch()"
            @blur="v$.peParty.any_criminal_history.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="auto">
          <label for="previously_detained">Previously detained?</label>
          <v-radio-group
            id="previously_detained"
            v-model="peParty.previously_detained"
            row
            :error-messages="getErrorMessages(v$.peParty.previously_detained)"
            class="mt-0"
            @input="v$.peParty.previously_detained.$touch()"
            @blur="v$.peParty.previously_detained.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="auto">
          <label for="presently_detained">Presently detained?</label>
          <v-radio-group
            id="presently_detained"
            v-model="peParty.presently_detained"
            row
            :error-messages="getErrorMessages(v$.peParty.presently_detained)"
            class="mt-0"
            @input="v$.peParty.presently_detained.$touch()"
            @blur="v$.peParty.presently_detained.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { SHARED_NAMESPACE } from '@/store/shared'

import { alertHandler } from '@/alertHandler'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard.vue'

export default {
  name: 'HistoryOverviewCard',
  components: { GenericCard },

  props: {
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return { }
  },

  validations () {
    return {
      peParty: {
        any_criminal_history: {},
        any_work_history: {},
        presently_detained: {},
        previously_detained: {},
        years_education: {},
      },
    }
  },

  computed: {
    locked: {
      get () {
        return this.peHistoryOverviewCardLock
      },

      set (value) {
        this.setPeHistoryOverviewCardLock(value)
      },
    },

    optionsFatherStatuses () { return this.getCachedDropdown('parties/father_status') },
    optionsMotherStatuses () { return this.getCachedDropdown('parties/mother_status') },

    ...mapGetters(PARTY_NAMESPACE, [
      'peHistoryOverviewCardLock',
      'peParty',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  watch: {

  },

  created () {
    this.initPeHistoryOverviewCard()
    this.getDropdownOptions({ path: 'parties/father_status' })
    this.getDropdownOptions({ path: 'parties/mother_status' })
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardUpdate () {
      return this.peHistoryOverviewCardUpdate({ id: this.peParty.id, section: this.peParty })
    },

    async onSectionUnlock () {
      return this.setPeHistoryOverviewCardLock(false)
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()

      return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'setPeHistoryOverviewCardLock',
    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeHistoryOverviewCard',
      'peHistoryOverviewCardUpdate',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
